import type { IconProps } from "@to/ui";

/** Keep the existing font glyph, without ligature words in headings/body text. */
export function Icon({ name, className, style, size, filled }: IconProps) {
  return <span aria-hidden="true" data-icon={name}
    className={`material-symbols-rounded ad-profile-icon${className ? ` ${className}` : ""}`}
    style={{ ...style, width: "1em", height: "1em", ...(size ? { fontSize: `${size}px` } : {}),
      ...(filled ? { fontVariationSettings: "'FILL' 1, 'wght' 200, 'GRAD' 0, 'opsz' 48" } : {}) }} />;
}
